import React from 'react';
import './PageStyles.css';

export default function CustomerTerms() {
  return (
    <div className="legal-page">
      <div className="page-hero hero-gradient">
        <div className="container text-center">
          <span className="section-label" style={{ background: 'rgba(103,183,247,0.15)', color: 'var(--secondary)' }}>Legal</span>
          <h1>Customer Terms</h1>
          <p>Last updated: January 1, 2025</p>
        </div>
      </div>
      <section>
        <div className="container">
          <div className="legal-content">
            <h2>1. Customer Eligibility</h2>
            <p>To use Pointfinity as a customer, you must be at least 13 years old and provide a valid mobile number for account registration. You must provide accurate and truthful information during registration.</p>

            <h2>2. Earning Points</h2>
            <p>Points are earned based on the rules set by each participating store. Points are credited to your wallet after a valid purchase is confirmed by the store. Pointfinity is not responsible for stores that fail to award points correctly.</p>

            <h2>3. Redeeming Points</h2>
            <p>Points can be redeemed at any participating store that supports redemptions. Redemption rules, including minimum thresholds and eligible products, are set by individual stores and may vary.</p>

            <h2>4. Points Expiry</h2>
            <p>Points may expire after a period of inactivity as defined by each store's policy. Expired points cannot be recovered. You will be notified of expiring points via the app if enabled.</p>

            <h2>5. Account Responsibility</h2>
            <p>You are responsible for keeping your login credentials secure. Any activity conducted under your account is your responsibility. Report unauthorized access immediately at support@pointfinity.com.</p>

            <h2>6. No Cash Value</h2>
            <p>Loyalty points have no monetary value and cannot be exchanged for cash. Points are only redeemable for goods, services, or discounts as defined by participating stores.</p>

            <h2>7. Prohibited Behavior</h2>
            <p>Customers must not:</p>
            <ul>
              <li>Attempt to manipulate or exploit the points system</li>
              <li>Create multiple accounts to gain extra points</li>
              <li>Transfer or sell points to other users</li>
              <li>Use the platform for fraudulent transactions</li>
            </ul>

            <h2>8. Account Termination</h2>
            <p>Pointfinity may suspend or delete your account if you violate these terms. All accumulated points will be forfeited upon account termination due to policy violation.</p>

            <h2>9. Changes to Customer Terms</h2>
            <p>These terms may be updated at any time. Continued use of the Pointfinity app constitutes acceptance of the updated terms.</p>

            <h2>10. Contact</h2>
            <p>For support, contact us at support@pointfinity.com.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
